import { useState } from 'react';
import { useReportHistoryQuery } from '@common/cache';

export const useReportHistoryModal = ({
  report_id,
  isOpen,
  onClose,
}: {
  report_id: string;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const [historyPage, setHistoryPage] = useState(1);
  const {
    data = {
      count: 0,
      history: [],
    },
    isPending,
  } = useReportHistoryQuery({ report_id, enabled: isOpen, page: historyPage });

  const handleCloseAction = () => {
    setHistoryPage(1);
    onClose();
  };

  return {
    historyList: data.history,
    count: data.count,
    isPending,
    historyPage,
    setHistoryPage,
    handleCloseAction,
  };
};
